module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "container-wrapper"
  }, [_c('div', {
    staticClass: "breadcrumb-wrapper"
  }, [_vm._v("用户列表")]), _vm._v(" "), _c('div', {
    staticClass: "search-wrapper"
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.queryParam,
      "label-width": "74px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户ID"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "placeholder": "精准搜索",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.exactUid),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "exactUid", $$v)
      },
      expression: "queryParam.exactUid"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "昵称/姓名"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "placeholder": "模糊搜索",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.fuzzyKeyword),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "fuzzyKeyword", $$v)
      },
      expression: "queryParam.fuzzyKeyword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机号"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "placeholder": "精准搜索",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.exactPhone),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "exactPhone", $$v)
      },
      expression: "queryParam.exactPhone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "角色"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "130px"
    },
    attrs: {
      "placeholder": "全部"
    },
    model: {
      value: (_vm.queryParam.roleId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "roleId", $$v)
      },
      expression: "queryParam.roleId"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": -1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "普通用户",
      "value": 0
    }
  }), _vm._v(" "), _vm._l((_vm.roles), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "性别"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "110px"
    },
    attrs: {
      "placeholder": "全部"
    },
    model: {
      value: (_vm.queryParam.gender),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "gender", $$v)
      },
      expression: "queryParam.gender"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": -1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "男",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "女",
      "value": 0
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "校区"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "filterable": "",
      "placeholder": "全部"
    },
    model: {
      value: (_vm.queryParam.unid),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "unid", $$v)
      },
      expression: "queryParam.unid"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.campuszones), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "禁言状态"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "130px"
    },
    attrs: {
      "placeholder": "全部"
    },
    model: {
      value: (_vm.queryParam.isBanned),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "isBanned", $$v)
      },
      expression: "queryParam.isBanned"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": -1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "正常",
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "禁言中",
      "value": 1
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "禁言时长"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "130px"
    },
    attrs: {
      "placeholder": "全部"
    },
    model: {
      value: (_vm.queryParam.banDurationStatus),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "banDurationStatus", $$v)
      },
      expression: "queryParam.banDurationStatus"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": -1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "临时禁言",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "永久禁言",
      "value": 2
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "低质状态"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "placeholder": "全部"
    },
    model: {
      value: (_vm.queryParam.isLowQuality),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "isLowQuality", $$v)
      },
      expression: "queryParam.isLowQuality"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": -1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "否",
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "是",
      "value": 1
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "账号身份"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "130px"
    },
    attrs: {
      "placeholder": "全部"
    },
    model: {
      value: (_vm.queryParam.accountIdentity),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "accountIdentity", $$v)
      },
      expression: "queryParam.accountIdentity"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": -1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "头号玩家",
      "value": 5
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-button', {
    staticClass: "margin-left-10",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.clickSearch
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.clickReset
    }
  }, [_vm._v("重置")])], 1), _vm._v(" "), _c('div', {
    staticClass: "action-wrapper"
  }, [_c('el-button', {
    on: {
      "click": _vm.clickTemplateDownload
    }
  }, [_vm._v("模版下载")]), _vm._v(" "), _c('el-upload', {
    attrs: {
      "show-file-list": false,
      "with-credentials": true,
      "accept": ".xls,.xlsx",
      "action": _vm.actionUrl,
      "name": "uploadFile",
      "before-upload": _vm.beforeUpload,
      "on-success": _vm.onSuccess,
      "on-error": _vm.onError
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("导入赠送")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.listData,
      "border": ""
    },
    on: {
      "selection-change": _vm.handleSelectionChange,
      "sort-change": _vm.handleSortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "64",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "用户ID",
      "prop": "uid",
      "min-width": "90"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "昵称",
      "prop": "nickname",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "姓名",
      "prop": "name",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "性别",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('div', [_vm._v(_vm._s(_vm.genderText(row.gender)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "手机号",
      "prop": "username",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "角色",
      "prop": "rname",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "账号身份",
      "min-width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('div', [_vm._v(_vm._s(_vm.accountIdentityText(row.accountIdentity)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "学校",
      "prop": "schoolName",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "校区",
      "prop": "unname",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "学号/职工号",
      "prop": "campusIdOrStuId",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "入学年份",
      "prop": "enrollmentYear",
      "min-width": "110"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "注册时间",
      "prop": "registrationDate",
      "min-width": "165",
      "sortable": "custom"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('div', [_vm._v(_vm._s(_vm.formatDateTime(row.registrationDate)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "最近发贴时间",
      "prop": "publishTime",
      "min-width": "165",
      "sortable": "custom"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('div', [_vm._v(_vm._s(_vm.formatDateTime(row.publishTime)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "禁言状态",
      "min-width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('div', {
          style: ({
            color: row.isBanned === 1 ? '#f56c6c' : ''
          })
        }, [_vm._v("\n            " + _vm._s(_vm.bannedStatusText(row.isBanned)) + "\n          ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "禁言时长",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('div', [_vm._v(_vm._s(_vm.banDurationStatusText(row)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "禁言原因",
      "prop": "banReason",
      "min-width": "120",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "禁言开始时间",
      "prop": "banStartTime",
      "min-width": "165",
      "sortable": "custom"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('div', [_vm._v(_vm._s(_vm.formatDateTime(row.banStartTime)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "禁言结束时间",
      "prop": "banEndTime",
      "min-width": "165",
      "sortable": "custom"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('div', [_vm._v(_vm._s(_vm.formatBanEndTime(row)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "低质标记状态",
      "min-width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('div', [_vm._v(_vm._s(_vm.lowQualityText(row.isLowQuality)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "标记原因",
      "prop": "lowQualityReason",
      "min-width": "140",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "标记时间",
      "prop": "lowQualityMarkTime",
      "min-width": "165",
      "sortable": "custom"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('div', [_vm._v(_vm._s(_vm.formatDateTime(row.lowQualityMarkTime)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "操作",
      "width": "300",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.clickSingleBan(row)
            }
          }
        }, [_vm._v(_vm._s(row.isBanned === 1 ? "解禁" : "禁言"))]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.clickSingleLowQuality(row)
            }
          }
        }, [_vm._v(_vm._s(row.isLowQuality === 1 ? "取消低质" : "标记低质"))]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.clickSingleIdentity(row)
            }
          }
        }, [_vm._v("设置身份")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination-wrapper"
  }, [_c('div', {
    staticClass: "bottom-action-wrapper"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.selectedRows.length <= 1
    },
    on: {
      "click": _vm.clickBatchBan
    }
  }, [_vm._v("修改批量禁言状态")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.selectedRows.length <= 1
    },
    on: {
      "click": _vm.clickBatchLowQuality
    }
  }, [_vm._v("修改批量低质状态")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.selectedRows.length <= 1
    },
    on: {
      "click": _vm.clickBatchIdentity
    }
  }, [_vm._v("批量设置身份")])], 1), _vm._v(" "), _c('div', {
    staticClass: "cursor-pagination"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "disabled": _vm.cursorStack.length === 0
    },
    on: {
      "click": _vm.clickPrevPage
    }
  }, [_vm._v("上一页")]), _vm._v(" "), _c('span', {
    staticClass: "page-info"
  }, [_vm._v("第 " + _vm._s(_vm.cursorStack.length + 1) + " 页")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "disabled": !_vm.hasMore
    },
    on: {
      "click": _vm.clickNextPage
    }
  }, [_vm._v("下一页")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "设置禁言状态",
      "size": "tiny",
      "modal-append-to-body": false,
      "destroy-on-close": true
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('el-button', {
          on: {
            "click": function($event) {
              _vm.banDialog.visible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": _vm.submitBatchBan
          }
        }, [_vm._v("确认")])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.banDialog.visible),
      callback: function($$v) {
        _vm.$set(_vm.banDialog, "visible", $$v)
      },
      expression: "banDialog.visible"
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.banDialog.form,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "禁言状态"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "220px"
    },
    model: {
      value: (_vm.banDialog.form.ban),
      callback: function($$v) {
        _vm.$set(_vm.banDialog.form, "ban", $$v)
      },
      expression: "banDialog.form.ban"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "正常",
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "禁言中",
      "value": 1
    }
  })], 1)], 1), _vm._v(" "), (_vm.banDialog.form.ban === 1) ? _c('el-form-item', {
    attrs: {
      "label": "禁言时长"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "220px"
    },
    model: {
      value: (_vm.banDialog.form.durationType),
      callback: function($$v) {
        _vm.$set(_vm.banDialog.form, "durationType", $$v)
      },
      expression: "banDialog.form.durationType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "1天",
      "value": "1d"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "7天",
      "value": "7d"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "30天",
      "value": "30d"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "90天",
      "value": "90d"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "永久禁言",
      "value": "forever"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.banDialog.form.ban === 1) ? _c('el-form-item', {
    staticClass: "reason-form-item",
    attrs: {
      "label": "禁言原因"
    }
  }, [_c('div', {
    staticClass: "reason-block"
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "请选择事由类型（可选）"
    },
    on: {
      "change": _vm.onBanReasonPresetKeyChange
    },
    model: {
      value: (_vm.banDialog.form.reasonPresetKey),
      callback: function($$v) {
        _vm.$set(_vm.banDialog.form, "reasonPresetKey", $$v)
      },
      expression: "banDialog.form.reasonPresetKey"
    }
  }, _vm._l((_vm.reasonPresetOptions), function(opt) {
    return _c('el-option', {
      key: opt.key,
      attrs: {
        "label": opt.label,
        "value": opt.key
      }
    })
  }), 1), _vm._v(" "), (_vm.banDialog.form.reasonPresetKey === _vm.reasonPresetOtherKey) ? _c('el-input', {
    staticClass: "reason-extra-input",
    attrs: {
      "type": "textarea",
      "rows": 2,
      "maxlength": 50,
      "placeholder": "请输入禁言原因（选填，最多50字）",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.banDialog.form.reasonExtra),
      callback: function($$v) {
        _vm.$set(_vm.banDialog.form, "reasonExtra", $$v)
      },
      expression: "banDialog.form.reasonExtra"
    }
  }) : _vm._e()], 1)]) : _vm._e()], 1), _vm._v(" "), _vm._v(" "), _c('div', {
    staticClass: "dialog-tip"
  }, [_vm._v("\n      * 禁言后禁止发帖、评论，个人主页动态、推荐流不可见；支持点赞和转发。\n      "), _c('span', {
    staticClass: "dialog-tip-highlight"
  }, [_vm._v("若当前用户为禁言状态，则会根据最新操作重新计算")])])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "设置低质状态",
      "size": "tiny",
      "modal-append-to-body": false,
      "destroy-on-close": true
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('el-button', {
          on: {
            "click": function($event) {
              _vm.lowQualityDialog.visible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": _vm.submitBatchLowQuality
          }
        }, [_vm._v("确认")])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.lowQualityDialog.visible),
      callback: function($$v) {
        _vm.$set(_vm.lowQualityDialog, "visible", $$v)
      },
      expression: "lowQualityDialog.visible"
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.lowQualityDialog.form,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "低质标记状态"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "220px"
    },
    model: {
      value: (_vm.lowQualityDialog.form.isLowQuality),
      callback: function($$v) {
        _vm.$set(_vm.lowQualityDialog.form, "isLowQuality", $$v)
      },
      expression: "lowQualityDialog.form.isLowQuality"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "否",
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "是",
      "value": 1
    }
  })], 1)], 1), _vm._v(" "), (_vm.lowQualityDialog.form.isLowQuality === 1) ? _c('el-form-item', {
    staticClass: "reason-form-item",
    attrs: {
      "label": "标记原因"
    }
  }, [_c('div', {
    staticClass: "reason-block"
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "请选择事由类型（可选）"
    },
    on: {
      "change": _vm.onLowQualityReasonPresetKeyChange
    },
    model: {
      value: (_vm.lowQualityDialog.form.reasonPresetKey),
      callback: function($$v) {
        _vm.$set(_vm.lowQualityDialog.form, "reasonPresetKey", $$v)
      },
      expression: "lowQualityDialog.form.reasonPresetKey"
    }
  }, _vm._l((_vm.reasonPresetOptions), function(opt) {
    return _c('el-option', {
      key: opt.key,
      attrs: {
        "label": opt.label,
        "value": opt.key
      }
    })
  }), 1), _vm._v(" "), (
    _vm.lowQualityDialog.form.reasonPresetKey === _vm.reasonPresetOtherKey
  ) ? _c('el-input', {
    staticClass: "reason-extra-input",
    attrs: {
      "type": "textarea",
      "rows": 2,
      "maxlength": 50,
      "placeholder": "请输入标记原因（选填，最多50字）",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.lowQualityDialog.form.reasonExtra),
      callback: function($$v) {
        _vm.$set(_vm.lowQualityDialog.form, "reasonExtra", $$v)
      },
      expression: "lowQualityDialog.form.reasonExtra"
    }
  }) : _vm._e()], 1)]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "设置身份",
      "modal-append-to-body": false
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('el-button', {
          on: {
            "click": function($event) {
              _vm.identityDialog.visible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.identitySubmitting
          },
          on: {
            "click": _vm.submitIdentity
          }
        }, [_vm._v("确认")])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.identityDialog.visible),
      callback: function($$v) {
        _vm.$set(_vm.identityDialog, "visible", $$v)
      },
      expression: "identityDialog.visible"
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "账号身份"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "disabled": !_vm.identityDialog.canSet
    },
    model: {
      value: (_vm.identityDialog.accountIdentity),
      callback: function($$v) {
        _vm.$set(_vm.identityDialog, "accountIdentity", $$v)
      },
      expression: "identityDialog.accountIdentity"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "头号玩家",
      "value": 5
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "无身份",
      "value": 0
    }
  })], 1)], 1)], 1), _vm._v(" "), (!_vm.identityDialog.canSet) ? _c('div', {
    staticClass: "dialog-tip dialog-tip-highlight"
  }, [_vm._v("\n      " + _vm._s(_vm.identityBlockReason) + "\n    ")]) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "批量设置身份",
      "size": "large",
      "modal-append-to-body": false
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('el-button', {
          on: {
            "click": function($event) {
              _vm.batchIdentityDialog.visible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.identitySubmitting
          },
          on: {
            "click": _vm.submitBatchIdentity
          }
        }, [_vm._v("确认")])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.batchIdentityDialog.visible),
      callback: function($$v) {
        _vm.$set(_vm.batchIdentityDialog, "visible", $$v)
      },
      expression: "batchIdentityDialog.visible"
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.batchIdentityDialog.rows,
      "border": "",
      "row-class-name": _vm.tableRowClassName
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "用户ID",
      "prop": "uid",
      "min-width": "90"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "昵称",
      "prop": "nickname",
      "min-width": "130",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "姓名",
      "prop": "name",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "手机号",
      "prop": "username",
      "min-width": "125"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "学校",
      "prop": "schoolName",
      "min-width": "130",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "当前身份",
      "min-width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_vm._v(_vm._s(_vm.accountIdentityText(row.accountIdentity)))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "可设置",
      "min-width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [(!row.canSet) ? _c('el-tooltip', {
          attrs: {
            "effect": "dark",
            "content": _vm.identityBlockReason,
            "placement": "top"
          }
        }, [_c('span', {
          staticClass: "identity-blocked"
        }, [_vm._v("无法设置")])]) : _c('span', [_vm._v("可设置")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "identity-batch-picker"
  }, [_c('span', {
    staticClass: "identity-batch-label"
  }, [_vm._v("账号身份")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "220px"
    },
    model: {
      value: (_vm.batchIdentityDialog.accountIdentity),
      callback: function($$v) {
        _vm.$set(_vm.batchIdentityDialog, "accountIdentity", $$v)
      },
      expression: "batchIdentityDialog.accountIdentity"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "头号玩家",
      "value": 5
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "无身份",
      "value": 0
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-61e7a8e0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/OperationManage/UserAdminister/CommunityUserListing/CommunityUserListing.vue
// module id = 1046
// module chunks = 0